<template>
    <div class="invoice" id="invocie-list">
        <SOSlotBase :bg-grey="true" :is-search="isSearchOpen">
            <template v-slot:title-bar>
                <SOTitleBar
                    :page-title="page.title"
                    :type="'back'"
                    @back="back"
                    :show-search="true"
                    @search="onToggleSearch"
                    v-if="!isSearchOpen"
                />
            </template>
            <template v-slot:search-bar>
                <SOSearchBar
                    v-if="isSearchOpen"
                    :context="'Invoice'"
                    :placeholder="`Ketik minimal 2 karakter`"
                    :value="search.key"
                    :data-count="countResults"
                    :search-information="`Nomor invoice, Nama Penerima, Nama outlet.`"
                    :waiting="search.searching"
                    @do-search="doSearch"
                    @loading="onSearch"
                    @close="onToggleSearch"
                />
            </template>
            <template v-slot:empty-state>
                <div>
                    <SOEmptyState
                        v-if="!invoiceTotal && !isFetching && !isSearchOpen"
                        :message="'Tidak ada Invoice'"
                        :subMessage="'Klik tombol + untuk menambah invoice'"
                    />
                    <SOEmptySearchState
                        v-if="!countResults && !isFetching && isSearchOpen && search.key.length > 1"
                        @action="resetSearchFilter"
                    />
                </div>
            </template>
            <template v-slot:skeleton v-if="isFetching && !isLoadMore">
                <div class="p-x-20 p-y-16 w-limit">
                    <SOLoadSearch v-if="isSearchOpen" />
                    <CardSkeleton v-else />
                </div>
            </template>
            <template v-slot:content v-if="!isFetching">
                <div v-if="(isMinExport || !isExporting)">
                    <SOExportProgressMinimized
                        v-if="isMinExport"
                        :processed-data="exportProgress.processed"
                        :total-data="exportProgress.total"
                        :context="'Invoice'"
                        :tracker-actions="`${modulName}/trackerExport`"
                        @on-success="checkExport"
                        @on-error="exportFail"
                    />
                    <SOExportMultipleFile
                        v-if="isMultipleExport"
                        :export-data="dataExport"
                        :export-data-length="countData"
                        :delete-cluster-actions="`${modulName}/exportDeleteCluster`"
                        :delete-master-actions="`${modulName}/exportDeleteMaster`"
                        @done="finishExport"
                    />
                </div>
                <div class="p-x-20" v-if="isMinExport || !isExporting">
                    <div v-if="invoiceTotal || !isSearchOpen">
                        <div class="card_breadcrum p-t-16">
                            <SOHeaderList
                                :title="`${invoiceTotal} Invoice`"
                                :show-filter="true"
                                @filter="toggleFilter(true)"
                            />
                        </div>
                        <div>
                            <CardInvoice
                                type-card="shadow"
                                :data-list="invoiceList"
                                :load-data="getListInvoice"
                                :search-key="search.key"
                            />
                        </div>
                    </div>
                    <div v-if="!isSearchOpen && validateAccess('list.create')">
                        <div class="flying-button-wrapper">
                            <div class="flying-inside">
                                <a class="flying-button" @click="goAddInvoice"></a>
                            </div>
                        </div>
                    </div>
                    <SOLoadMoreLoading :id="'load-more-invoice'" :loading="isLoadMore" />
                </div>
            </template>
            <template v-slot:filter>
                <div>
                    <FilterInvoice :load-invoice="loadInvoice"></FilterInvoice>
                </div>
            </template>
            <template v-slot:export-import>
                <div class="vh-100" v-if="isExporting && !isMinExport">
                    <SOExportProgress
                        :context="'Invoice'"
                        :tracker-actions="`${modulName}/trackerExport`"
                        @on-success="checkExport"
                        @on-error="exportFail"
                        @minimized-export="minimizedExport"
                    />
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";

import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOLoadSearch from "@/so-components/global/ui/SOLoadSearch";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState.vue";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import SOExportProgress from "@/so-components/global/ui/SOExportProgress";
import SOExportProgressMinimized from "@/so-components/global/ui/SOExportProgressMinimized";
import SOExportMultipleFile from "@/so-components/global/ui/SOExportMultipleFile";

import CardSkeleton from "../components/CardSkeleton.vue";
import CardInvoice from "../components/CardInvoice.vue";
import FilterInvoice from "../components/FilterInvoice.vue";

export default {
    name: "InvoiceList",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOHeaderList,
        SOSearchBar,
        SOLoadSearch,
        SOLoadMoreLoading,
        SOEmptyState,
        SOEmptySearchState,
        SOExportProgress,
        SOExportProgressMinimized,
        SOExportMultipleFile,
        CardSkeleton,
        CardInvoice,
        FilterInvoice,
    },
    data() {
        return {
            skipReload: [
                "invoice.add",
                "invoice.list",
                "invoice.list.batal_invoice",
                "invoice.list.batal_hapus",
                "invoice.list.hapus_invoice",
                "invoice.list.pembatalan_invoice",
                "invoice.list.export",
                "invoice.send.wa",
            ],
            page: {
                title: "Invoice",
                loading: false,
                from: false,
            },
            search: {
                open: false,
                searching: false,
                key: "",
            },
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.page.from = from.name;
            if (vm.skipReload.findIndex((sr) => sr === from.name) === -1) {
                vm.init();
            } else {
                if (!vm.invoiceTotal) {
                    vm.loadInvoice();
                }
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        if (from.name === "invoice.list") {
            if (to.name !== "dashboard") {
                this.setLastInvoiceView({});
            } else {
                this.setLastItem();
            }
        }
        next();
    },
    watch: {
        "search.open": function (nS, oS) {
            if (nS !== oS && nS === false) {
                this.loadInvoice();
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            invoiceList: "invoiceList",
            invoiceTotal: "invoiceTotal",
            invoiceShow: "invoiceShow",
            invoiceView: "invoiceView",
            isLoadMore: "isLoadMore",
            exportData: "exportData",
            exportProgress: "exportProgress",
        }),
        ...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem",
        }),
        countResults() {
            return this.invoiceTotal;
        },
        isSearchOpen() {
            return this.search.open;
        },
        isFetching() {
            return this.page.loading;
        },
        modulName() {
            return moduleName;
        },
        isMinExport() {
            return this.exportData.minimized;
        },
        isExporting() {
            return this.exportData.exporting;
        },
        isMultipleExport() {
            return this.exportData.multiple;
        },
        dataExport() {
            return this.exportData.data;
        },
        countData() {
            return this.exportData.dataLength;
        },
    },
    methods: {
        ...mapActions({
            getListInvoice: `${moduleName}/getListInvoice`,
            setFilter: `${moduleName}/setFilter`,
            setLastInvoiceView: `${moduleName}/setLastInvoiceView`,
            resetList: `${moduleName}/resetList`,
            resetPage: `${moduleName}/resetPage`,
            toggleExport: `${moduleName}/toggleExport`,
            setMinimizedExport: `${moduleName}/setMinimizedExport`,
            setMultipleExport: `${moduleName}/setMultipleExport`,
            trackerExport: `${moduleName}/trackerExport`,
            setDataExport: `${moduleName}/setDataExport`,
            setCountDataExport: `${moduleName}/setCountDataExport`,
            setProgressExport: `${moduleName}/setProgressExport`,
            setGrandTotal: `${moduleName}/setGrandTotal`,
        }),
        setFetching(val) {
            this.page.loading = val;
        },
        async init() {
            if (this.page.from !== "invoicePenjadwalan") {
                await this.resetSearchFilter();
            }
            this.loadInvoice();
        },
        async loadInvoice(key = "") {
            await this.setFetching(true);
            await this.resetDataList();
            await this.resetPagination();
            await this.getListInvoice({ key });

            this.setFetching(false);
            this.onSearch(false);
            this.scrollTo();
        },
        back() {
            this.$router.go(-1);
        },
        onSearch(val) {
            this.search.searching = val;
        },
        onToggleSearch() {
            this.search.open = !this.search.open;
            if (!this.search.open) {
                this.search.key = "";
            }
        },
        doSearch(key) {
            this.search.key = key;
            this.loadInvoice(key);
        },

        toggleFilter(val) {
            this.setFilter(val);
        },
        resetSearchFilter() {
            this.resetFilter();
            this.search.key = "";
        },
        exportFail() {
            this.toggleExport(false);
        },
        minimizedExport(data) {
            this.setMinimizedExport(true);
            this.setProgressExport(data);
        },
        async resetFilter() {
            await this.$store.commit("filterGlobalModule/resetFilterItem");

            let temp = {
                ...this.filterItem,
                periode_state: "created_at",
            };



            /**Buka jika menggunakan set default periode tanggal */
            // temp.periode = {
            //     endDate: this.$moment().format("YYYY-MM-DD"),
            //     filterBy: "periode",
            //     startDate: this.$moment()
            //         .subtract(1, "days")
            //         .format("YYYY-MM-DD"),
            //     month: "",
            //     year: "",
            // };
            await this.$store.commit("filterGlobalModule/setFilterItem", temp);
        },
        resetPagination() {
            this.resetPage({ target: "invoice" });
        },
        resetDataList() {
            this.resetList({ target: "invoice" });
        },

        async goAddInvoice() {
            await this.setGrandTotal(0);
            this.$router.push({ name: "invoice.add" });
        },
        finishExport() {
            this.setMultipleExport(false);
            this.setDataExport([]);
        },
        async checkExport() {
            this.toggleExport(false);
            this.setMinimizedExport(false);
            this.setMultipleExport(false);

            let tracker = await this.trackerExport();
            if (!tracker.success) {
                return;
            }

            this.setCountDataExport(tracker.data.length);

            if (tracker.data.info_data_export.length > 0) {
                if (tracker.data.status === 1) {
                    this.setMultipleExport(true);
                    this.setDataExport(tracker.data.info_data_export);
                    if (this.dataExport.length > 0) {
                        this.dataExport.forEach((v) => {
                            v["downloaded"] = false;
                        });
                    }
                } else {
                    this.setMinimizedExport(true);
                }
            }
        },
        scrollTo() {
            let el = document.getElementById(this.invoiceView.id);

            if (el) {
                setTimeout(() => {
                    el.scrollIntoView();
                    document.documentElement.scrollTop = document.documentElement.scrollTop - 53;
                }, 100);
            }
        },
        setLastItem() {
            let newInv = this.invoiceShow.sort(function (a, b) {
                if (a.yDir < b.yDir) {
                    return -1;
                }
                if (a.yDir > b.yDir) {
                    return 1;
                }
                return 0;
            });

            if (newInv[0]) {
                this.setLastInvoiceView(newInv[0]);
            }
        },
    },
};
</script>
